import ImportFromCSVModalBody from "../../../components/ImportFromCSVModalBody";
import { triggerRefresh } from "../../../utils/refreshRegistry";

const expectedHeaders = ["ID", "Date", "Title", "Speaker", "AudioURL", "VideoURL", "SpecialMeetingName"];

const headerDescriptions = [
  { name: "ID", description: "Row identifier (not used during import, but column must be present)" },
  { name: "Date", description: "Date of the message in YYYY-MM-DD format (e.g. 2024-01-15)" },
  { name: "Title", description: "Title of the message" },
  { name: "Speaker", description: "Name of the speaker" },
  { name: "AudioURL", description: "URL to the audio file (MP3). Can be empty." },
  { name: "VideoURL", description: "URL to the video (e.g. YouTube link). Can be empty." },
  { name: "SpecialMeetingName", description: "Name of the special meeting this message belongs to (must match an existing special meeting)" },
];

function buildRow(row) {
  return {
    date: (row.Date || "").trim(),
    title: (row.Title || "").trim(),
    speaker: (row.Speaker || "").trim(),
    videoUrl: (row.VideoURL || "").trim(),
    audioUrl: (row.AudioURL || "").trim(),
    specialMeetingName: (row.SpecialMeetingName || "").trim(),
  };
}

function ImportSpecialMessagesFromCSVModalBody({ closeModal }) {
  return (
    <ImportFromCSVModalBody
      closeModal={closeModal}
      expectedHeaders={expectedHeaders}
      headerDescriptions={headerDescriptions}
      apiEndpoint="api/special-meeting-messages/all/"
      buildRow={buildRow}
      onSuccess={() => triggerRefresh("specialMessages")}
      entityName="Special Meeting Messages"
    />
  );
}

export default ImportSpecialMessagesFromCSVModalBody;
